import SimpleParallax from "simple-parallax-js/vanilla";

// Common function to apply 3D transform interactions
function apply3DEffect(selector, intensity) {

  const elements = document.querySelectorAll(selector);

  elements.forEach((el) => {
    const height = el.clientHeight;
    const width = el.clientWidth;

    el.addEventListener('mousemove', (e) => {
      const xVal = e.layerX;
      const yVal = e.layerY;

      const yRotation = intensity * ((xVal - width / 2) / width);
      const xRotation = -intensity * ((yVal - height / 2) / height);

      const transform = `perspective(500px) rotateX(${xRotation}deg) rotateY(${yRotation}deg)`;
      el.style.transform = transform;
    });

    el.addEventListener('mouseout', () => {
      el.style.transform = 'perspective(500px) scale(1) rotateX(0) rotateY(0)';
    },120);

    el.addEventListener('mousedown', () => {
      el.style.transform = 'perspective(500px) scale(0.9) rotateX(0) rotateY(0)';
    },120);

    el.addEventListener('mouseup', () => {
      el.style.transform = 'perspective(500px) scale(1.1) rotateX(0) rotateY(0)';
    },120);
  });
}

// Apply to both classes with different intensity
apply3DEffect('.vayu_block_styling-effect7', 8);
apply3DEffect('.vayu_block_styling-overlay-effect', 10);

document.addEventListener('DOMContentLoaded', () => {
    const images = document.querySelectorAll('img[data-parallax="true"]');

    images.forEach((img) => {
        const options = {
            orientation: img.dataset.orientation || 'up',
            delay: parseFloat(img.dataset.delay || 0),
            scale: parseFloat(img.dataset.scale || 1.2),
            transition: img.dataset.transition || 'cubic-bezier(0,0,0,1)',
            overflow: img.dataset.overflow === 'true',
            maxTransition: parseFloat(img.dataset.maxTransition || 60)
        };

        new SimpleParallax(img, options);
    });
});